import { orderTypes } from 'shared/constants/orderTypes';

export const GET_INSTRUMENT = 'GET_INSTRUMENT';
export const GET_INSTRUMENT_SUCCESS = 'GET_INSTRUMENT_SUCCESS';
export const GET_INSTRUMENT_ERROR = 'GET_INSTRUMENT_ERROR';

export const GET_INSTRUMENT_DOCUMENTS = 'GET_INSTRUMENT_DOCUMENTS';
export const GET_INSTRUMENT_DOCUMENTS_SUCCESS = 'GET_INSTRUMENT_DOCUMENTS_SUCCESS';
export const GET_INSTRUMENT_DOCUMENTS_ERROR = 'GET_INSTRUMENT_DOCUMENTS_ERROR';

export const GET_INSTRUMENT_PRODUCTS = 'GET_INSTRUMENT_PRODUCTS';
export const GET_INSTRUMENT_PRODUCTS_SUCCESS = 'GET_INSTRUMENT_PRODUCTS_SUCCESS';
export const GET_INSTRUMENT_PRODUCTS_ERROR = 'GET_INSTRUMENT_PRODUCTS_ERROR';

export const GET_INSTRUMENT_RATING_NEWS = 'GET_INSTRUMENT_RATING_NEWS';
export const GET_INSTRUMENT_RATING_NEWS_SUCCESS = 'GET_INSTRUMENT_RATING_NEWS_SUCCESS';
export const GET_INSTRUMENT_RATING_NEWS_ERROR = 'GET_INSTRUMENT_RATING_NEWS_ERROR';

export const GET_INSTRUMENT_RESEARCH = 'GET_INSTRUMENT_RESEARCH';
export const GET_INSTRUMENT_RESEARCH_SUCCESS = 'GET_INSTRUMENT_RESEARCH_SUCCESS';
export const GET_INSTRUMENT_RESEARCH_ERROR = 'GET_INSTRUMENT_RESEARCH_ERROR';

export const REQUEST_INSTRUMENT_RATING = 'REQUEST_INSTRUMENT_RATING';
export const REQUEST_INSTRUMENT_RATING_SUCCESS = 'REQUEST_INSTRUMENT_RATING_SUCCESS';
export const REQUEST_INSTRUMENT_RATING_ERROR = 'REQUEST_INSTRUMENT_RATING_ERROR';

export const REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA = 'REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA';
export const REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA_SUCCESS =
  'REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA_SUCCESS';
export const REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA_ERROR =
  'REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA_ERROR';

export const getInstrumentAction = ({ id }) => ({
  type: GET_INSTRUMENT,
  payload: {
    id,
  },
});

export const getInstrumentDocumentsAction = ({ instrumentId }) => ({
  type: GET_INSTRUMENT_DOCUMENTS,
  payload: {
    instrumentId,
  },
});

export const getInstrumentProductsAction = ({ instrumentId }) => ({
  type: GET_INSTRUMENT_PRODUCTS,
  payload: {
    instrumentId,
  },
});

export const getInstrumentRatingNewsAction = ({ entityId, query, page, limit }) => ({
  type: GET_INSTRUMENT_RATING_NEWS,
  payload: {
    entityId,
    query,
    type: 'ENTITY_RATING_NEWS',
    page,
    limit,
  },
});

export const getInstrumentResearchAction = ({
  entityId,
  query,
  page,
  limit,
  settings,
  industryCode,
}) => ({
  type: GET_INSTRUMENT_RESEARCH,
  payload: {
    entityId,
    query,
    type: 'INDUSTRY_RESEARCH',
    page,
    limit,
    settings,
    industryCode,
  },
});

export const requestInstrumentRatingAction = ({ id, level }) => ({
  type: REQUEST_INSTRUMENT_RATING,
  payload: {
    id,
    type: orderTypes.INSTRUMENT,
    frequency: 0,
    productCategory: level,
    purchaseType: 'ONE_TIME',
  },
});

export const requestInstrumentRatingAndFetchDataAction = ({ id, level }) => ({
  type: REQUEST_INSTRUMENT_RATING_AND_FETCH_DATA,
  payload: {
    id,
    type: orderTypes.INSTRUMENT,
    frequency: 0,
    level,
    purchaseType: 'ONE_TIME',
  },
});
